export default "__VITE_ASSET__B$gbWOEF__"